import { IObservableArray, makeAutoObservable, observable } from "mobx";
import {
  isLearningPathResourceResponseDTO,
  LearningPathResourceResponseApi,
} from "../LearningPath/LearningPathResource";
import {
  isModuleWithResourcesResponseDTO,
  isModuleWithResourcesWithSomeTaskInfoResponseDTO,
  ModuleWithResourcesAndTasksResponseApi,
} from "../Module/Module";
import { isGroupIdResponseDTO } from "./GroupId";

export interface GroupLearningPathResponseApi {
  groupLearningPathName: string;
  groupId: string;
  groupName: string;
  groupLearningPathModules: (ModuleWithResourcesAndTasksResponseApi & {
    isModuleOpen: boolean;
  })[];
  groupLearningPathResources: LearningPathResourceResponseApi[];
}

export let isGroupLearningPathResponseDTO = (
  variable: unknown
): variable is GroupLearningPathResponseApi => {
  return (
    isGroupIdResponseDTO(variable) &&
    "groupName" in variable &&
    typeof variable.groupName === "string" &&
    "groupLearningPathName" in variable &&
    typeof variable.groupLearningPathName === "string" &&
    "groupLearningPathModules" in variable &&
    Array.isArray(variable.groupLearningPathModules) &&
    (variable.groupLearningPathModules.length === 0 ||
      variable.groupLearningPathModules.reduce(
        (doArrayConsistOfStudents, groupModules) =>
          doArrayConsistOfStudents &&
          isModuleWithResourcesWithSomeTaskInfoResponseDTO(groupModules) &&
          "isModuleOpen" in groupModules &&
          typeof groupModules.isModuleOpen === "boolean"
      )) &&
    "groupLearningPathResources" in variable &&
    Array.isArray(variable.groupLearningPathResources) &&
    (variable.groupLearningPathResources.length === 0 ||
      variable.groupLearningPathResources.reduce(
        (doArrayConsistOfStudents, groupResources) =>
          doArrayConsistOfStudents &&
          isLearningPathResourceResponseDTO(groupResources)
      ))
  );
};

export class EmptyGroupLearningPathResponseImpl
  implements GroupLearningPathResponseApi
{
  groupLearningPathName = "";
  groupId = "";
  groupName = "";
  groupLearningPathModules = [];
  groupLearningPathResources = [];
}

export class ObservableGroupLearningPathPropImpl
  implements GroupLearningPathResponseApi
{
  groupLearningPathName: string;
  groupId: string;
  groupName: string;
  groupLearningPathModules: IObservableArray<
    ModuleWithResourcesAndTasksResponseApi & {
      isModuleOpen: boolean;
    }
  >;
  groupLearningPathResources: IObservableArray<LearningPathResourceResponseApi>;

  constructor(groupLearningPath: GroupLearningPathResponseApi) {
    this.groupId = groupLearningPath.groupId;
    this.groupName = groupLearningPath.groupName;
    this.groupLearningPathName = groupLearningPath.groupLearningPathName;
    this.groupLearningPathModules = observable.array(
      groupLearningPath.groupLearningPathModules
    );
    this.groupLearningPathResources = observable.array(
      groupLearningPath.groupLearningPathResources
    );
    makeAutoObservable(this);
  }

  onChangeResources = (
    learningPathResources: LearningPathResourceResponseApi[]
  ) => {
    this.groupLearningPathResources.replace(learningPathResources);
  };
}
